export default "__VITE_PUBLIC_ASSET__398e0590__"